import '../../../sass/screens/auction_registration/index.scss';
import { ARP_NAVIGATION_EVENTS } from '../../event_bus_modules/auction_registration_navigation';

$(() => {
  const auctionRegistrationContainer = $('#auction-registration-container');
  const pageLoader = auctionRegistrationContainer.find('.page-loader');
  const pageContent = auctionRegistrationContainer.find('.page-content');

  const setAuctionRegistrationMinHeight = () => {
    const headerHeight = $('#navigation').height();
    const footerHeight = $('.page-footer').height();
    const headerAndFooterHeight = headerHeight + footerHeight;
    auctionRegistrationContainer.css({
      minHeight: `calc(100vh - ${headerAndFooterHeight}px)`,
    });
  };
  const displayLoader = () => {
    pageLoader.show();
    pageContent.hide();
    $(document).scrollTop(0);
  };

  const hideLoader = () => {
    pageLoader.hide();
    pageContent.show();
    $(document).scrollTop(0);
  };

  EVENT_BUS.on(ARP_NAVIGATION_EVENTS.NAVIGATION_BUTTON_CLICK, displayLoader);
  EVENT_BUS.on(ARP_NAVIGATION_EVENTS.CLEAR_LOADER, hideLoader);

  setAuctionRegistrationMinHeight();
  $(window).on('resize', setAuctionRegistrationMinHeight);

  $(window).on('unload', () => {
    $(window).off('resize', setAuctionRegistrationMinHeight);
  });
});
